<template>
  <vs-card id="create-review-order-loading" class="vs-con-loading__container">
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="$t('create') + ' ' + $tc('review_order')"
      :subtitle="null"
      finishButtonText="Submit"
      @on-complete="finish"
    >
      <template slot="step" slot-scope="props">
        <wizard-step
          :tab="props.tab"
          :transition="props.transition"
          :key="props.tab.title"
          :index="props.index"
        >
        </wizard-step>
      </template>

      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left">
          <vs-button
            v-if="props.activeTabIndex === 1"
            @click.native="props.prevTab()"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="Check"
          >
            {{ $t('previous') | capitalize }}
          </vs-button>
        </div>
        <div class="wizard-footer-right">
          <vs-button
            v-if="props.activeTabIndex === 0"
            @click.native="props.nextTab()"
            :disabled="invoices.tables.length === 0"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="Check"
          >
            {{ $t('next') | capitalize }}
          </vs-button>
          <vs-button
            v-else-if="props.activeTabIndex === 1"
            @click.native="props.nextTab()"
            :disabled="!status"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="Check"
          >
            {{ $t('next') | capitalize }}
          </vs-button>
          <vs-button
            v-else
            @click="finish"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="Check"
          >
            {{ $t('done') | capitalize }}
          </vs-button>
        </div>
      </template>

      <tab-content
        :title="$t('invoice_file') | capitalize"
        class="mb-5"
        icon="feather icon-file"
        :before-change="validateInvoice"
      >
        <review-order-import v-model="invoices" />
      </tab-content>

      <tab-content
        :title="$t('validations') | capitalize"
        class="mb-5"
        icon="feather icon-check"
        :before-change="submitInvoice"
      >
        <review-order-validation :data="invoiceErrors" :files="files" @refresh="validateInvoice()" />
      </tab-content>

      <tab-content
        :title="$t('resume') | capitalize"
        class="mb-5"
        icon="feather icon-file-text"
      >
        <review-order-import-resume
          :data="invoices"
          :invoiceInfo="invoiceInfo"
        />
      </tab-content>
    </form-wizard>
    <vs-popup
      :title="$t('attention')|capitalize"
      color="danger"
      :active.sync="modal"
    >
      <div>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-2"
        >
        <vs-col>
          <div v-for="(error,index) in errorValidations" :key="index">
            {{error}}
          </div>
        </vs-col>
        </vs-row>
        <vs-row vs-type="flex"
            vs-justify="center"
            vs-align="center">
             <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2"
          >
            <vs-button
              color="primary"
              class="w-full"
              @click="modal = false"
              >{{ $t('ok') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </vs-card>
  
</template>

<script>
import { FormWizard, WizardStep, TabContent } from 'vue-form-wizard'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate'
import vSelect from 'vue-select'
import reviewOrder from '@/http/requests/reviewOrder'
import ReviewOrderImport from './components/ReviewOrderImport'
import ReviewOrderValidation from './components/ReviewOrderValidation'
import ReviewOrderTable from './components/ReviewOrderTable'
import ReviewOrderImportResume from './components/ReviewOrderImportResume'
export default {
  components: {
    FormWizard,
    WizardStep,
    TabContent,
    'v-select': vSelect,
    ReviewOrderImport,
    ReviewOrderValidation,
    ReviewOrderTable,
    ReviewOrderImportResume
  },

  computed: {
    isLoading () {
      return this.loading.submit
    }
  },

  data () {
    return {
      files: [],
      loading: {
        submit: false
      },
      invoices: {
        tables: []
      },
      invoiceErrors: [],
      invoiceInfo: [],
      status: false,
      modal: false,
      errorValidations:[]
    }
  },

  methods: {
    validateInvoice () {
      const invoice_items = this.invoices.tables.map(table => table.json)
      this.files = this.invoices.tables.map(table => table.fileName)
      this.invoiceErrors = []
      this.files.forEach(i => {
        this.invoiceErrors.push([])
      })
      const params = {
        invoice_items,
        validation: true
      }
      this.loading.submit = true
      return reviewOrder
        .storeInvoiceItems(params)
        .then(res => {
          this.status = res.data.status
          if (!this.status) {
            this.invoiceErrors = res.data.errors
          }
          this.loading.submit = false
          //this.status = true
          return true
        })
        .catch(res => {
          this.loading.submit = false
          return true
        })
    },
    submitInvoice () {
      const invoice_items = this.invoices.tables.map(table => table.json)
      const params = {
        invoice_items,
        is_ro: this.invoices.isReviewAtOrigin
      }
      this.loading.submit = true
      return reviewOrder
        .storeInvoiceItems(params)
        .then(res => {
          this.invoiceInfo = res.data.data
          // this.invoiceInfo = [{
          //   invoice:'asdasd',
          //   bundle:'bundle',
          //   code:'1231321'
          // }]
          this.review_order_id=res.data.review_order_id
          this.loading.submit = false
          this.$vs.notify({
            color: 'success',
            title: 'Correct',
            text: 'Review Order Saved'
          })
          return true
        })
        .catch(res => {
          this.loading.submit = false
          return true
        })
    },
    finish () {
      this.$router.push('/review_orders/'+this.review_order_id)
    },
    checkNoDuplicateFolio(invoices){
        let out=false
        let index=invoices.tables.length-1
        let item=[]
        if(invoices.tables.length>0){
          item=invoices.tables[index].json[0]
          invoices.tables.forEach((element,key) => {
            if(element.json[0]['Folio Factura']==item['Folio Factura']
              && key!=index && !out){
              out=true
              this.errorValidations.push('El Folio Factura de este archivo ya se encuentra en la lista de Archivos. El archivo NO fue agregado a la lista.')
            }
          })
        }
        return out
    },
    checkDuplicateNoPartWareHouse(invoices){
      if(invoices.tables.length>0){
        let compare=''
        let duplicate_found=false
        invoices.tables.forEach(item => {
          item.json.forEach((element,index) => {
            compare=element['No. parte']+'|'+element['WareHouse']
            item.json.forEach((obj,indice) => {
            if(obj['No. parte']+'|'+obj['WareHouse']==compare && index!=indice && !duplicate_found){
                this.errorValidations.push('No. parte y Warehouse Duplicado. No.Parte: '+ obj['No. parte']+' | WareHouse: '+obj['WareHouse'])
                duplicate_found=true
              }
            })
          })
        })
        return duplicate_found
      }
    }
  },
  mounted () {},
  mixins: [loading, validate],
  watch: {
    isLoading (val) {
      if (val) {
        this.openLoading('create-review-order-loading')
      } else {
        this.closeLoading('create-review-order-loading')
      }
    },
    invoices(){
      this.errorValidations=[]
        let out=this.checkNoDuplicateFolio(this.invoices)
        let out2=this.checkDuplicateNoPartWareHouse(this.invoices)
        if(out || out2){
          this.modal=true
          let index=this.invoices.tables.length-1
          this.invoices.tables.splice( index, 1 )
        }
    }
  }
}
</script>

<style>
.detail-th {
  padding: 0;
}

.linea {
  width: 40%;
  border-top: 3px solid #bc1300;
  position: relative;
  top: 10px;
  float: left;
}

.leyenda {
  width: 20%;
  font-weight: bold;
  font-size: 16px;
  float: left;
}

.vue-swatches__trigger__wrapper {
  display: block;
  cursor: pointer;
}

.custom-form-label {
  font-size: 14px;
}

.icon-text {
  font-size: 18px;
  vertical-align: 50%;
}

</style>
